import { Select } from '@nazka/nazka.mapframe.components';

import { useTranslation } from '@utils/i18n/i18n.consumers';

function TranslatedSelect(props) {
  const { lang } = useTranslation();

  return <Select key={lang} {...props} />;
}

export default TranslatedSelect;
